import { render, staticRenderFns } from "./afterSalesStatistic.vue?vue&type=template&id=4139632f&scoped=true"
import script from "./afterSalesStatistic.vue?vue&type=script&lang=js"
export * from "./afterSalesStatistic.vue?vue&type=script&lang=js"
import style0 from "./afterSalesStatistic.vue?vue&type=style&index=0&id=4139632f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4139632f",
  null
  
)

export default component.exports